
const digest = '77ad1899112799d4cbf3ea998392f2c718142a14a4891f3c3756a822e65afdaa';
const classes = {"wrapper":"_wrapper_1xh9j_1"};
const css = `._wrapper_1xh9j_1 {
  border: 1px solid #eaedf3;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  